module.exports = __webpack_public_path__ + "static/img/logo.39b91e5f.png";